import React, { ChangeEvent } from 'react';
import { QuoteModel } from '../../model/autogen/QuoteModel';
import FormControl from "@material-ui/core/FormControl/FormControl";
import FormLabel from "@material-ui/core/FormLabel/FormLabel";
import { TextField, ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary, Typography } from '@material-ui/core';
import DatePicker from "material-ui-pickers/DatePicker";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Keyboard from "@material-ui/icons/Keyboard";
import * as moment from "moment";
import { DATE_DISPLAY_FORMAT } from "../date-display-format";
import PersonListEditor from "./person-list-editor";
import { PersonModel } from "../../model/autogen/PersonModel";
import { Spacer } from '../utility-components';
import { isArrayNullOrEmpty } from "../../utils/array";
import Dropzone from "react-dropzone";
import { LinearProgress } from "@material-ui/core";
import DEFAULT_DROPZONE_STYLE from "../dropzone-style";
import Grid from "@material-ui/core/Grid/Grid";
import TagListEditor from "../material/tag-list-editor";
import { TagModel } from "../../model/autogen/TagModel";
import ExpandMore from "@material-ui/icons/ExpandMore";


export interface IEditQuoteProps {
    onQuoteChange: ((event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void) | undefined;
    onDateChange: (date: moment.Moment) => void
    quote: QuoteModel;
    onFetchSubjects: (query: string) => Promise<PersonModel[]>;
    onResolveSubjects: (people: number[]) => Promise<PersonModel[]>;
    onSubjectsChanged: (list: PersonModel[]) => void;
    onFileDrop: (acceptedFiles: File[], rejectedFiles: File[]) => Promise<void>;
    isUploadingFiles: boolean;
    onSearchTags: (query: string, isResourceOnly: boolean) => Promise<TagModel[]>;
    onResolveTags: (tags: string[]) => Promise<TagModel[]>;
    onTagsChanged: (list: TagModel[]) => void;
    customDecoration?: JSX.Element;
    expanded?: boolean;
    editPage?: boolean

}

export const EditQuote = (props: IEditQuoteProps) => {
    const { quote, expanded, editPage } = props
    const initialPeopleIds = (quote.subjects || []).map(qs => qs.subject.id);

    return <>
        <ExpansionPanel defaultExpanded={editPage || expanded} style={{backgroundColor: "#fbfbfb"}}>
                
            <ExpansionPanelSummary expandIcon={<ExpandMore />}>
                <div style={{display: "flex", alignItems: "center", width: "100%"}}>
                    <div style={{width: "100%", marginRight: "10px"}}> 
                        <Typography variant="caption">Date of Transcript</Typography>
                        <Typography gutterBottom>{quote.dateOfQuote === null || quote.dateOfQuote === undefined ? "" : moment(quote.dateOfQuote).format("Do MMMM YYYY")}</Typography>
                    </div>
                    <div style={{width: "100%"}}>
                        <Typography variant="caption">{quote.topic != "" ? "Transcript Topic" : ""}</Typography>
                        <Typography variant="h6">{quote.topic}</Typography>
                    </div>
                </div>
                <div style={{width: '100%', height: '50px', display: "flex", justifyContent: "flex-end"}} >
                    {props.customDecoration && props.customDecoration}
                </div>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
                <div style={{minWidth: 'calc(100% - 50px)'}}>
                    <DatePicker style={{marginBottom: '20px'}} format={DATE_DISPLAY_FORMAT} label="Date of Transcript" autoOk clearable showTodayButton value={quote.dateOfQuote} onChange={props.onDateChange} leftArrowIcon={<ChevronLeft />} rightArrowIcon={<ChevronRight />} keyboardIcon={<Keyboard />} />
                    <TextField onChange={props.onQuoteChange} name={"topic"} multiline={true} value={quote.topic} label={"Topic"} style={{minWidth: "100%", marginBottom: '20px'}} />
                    <TextField onChange={props.onQuoteChange} name={"phrase"} multiline={true} value={quote.phrase} style={{ minWidth: '100%' }} label={"Transcript"} />
                    <Spacer />
                    <PersonListEditor tweet={false} label="Subjects of Transcript" key={quote.id} initialPeopleIds={initialPeopleIds} onFetchPeople={props.onFetchSubjects} onPeopleChanged={props.onSubjectsChanged} onResolvePeople={props.onResolveSubjects} />
                    <Spacer />
                    <Typography>* At least one <strong>Link</strong> or <strong>File</strong></Typography>
                    <TextField onChange={props.onQuoteChange} name={"sourceURL"} multiline={true} value={quote.sourceURL} style={{ minWidth: '100%' }} label={"Link to Transcript"} type={"url"} />
                    <Spacer />
                    <FormControl>
                        <FormLabel>Files to add</FormLabel>
                        <Dropzone multiple={false} onDrop={props.onFileDrop} style={DEFAULT_DROPZONE_STYLE.default} disabledStyle={DEFAULT_DROPZONE_STYLE.disabled} activeStyle={DEFAULT_DROPZONE_STYLE.active} acceptStyle={DEFAULT_DROPZONE_STYLE.active} rejectStyle={DEFAULT_DROPZONE_STYLE.rejected}>
                            <Grid justify="center" container spacing={24}>
                                <Grid item xs={12}>
                                    {(() => {
                                        if (!isArrayNullOrEmpty(quote.assignFiles)) {
                                            return <>
                                                {props.isUploadingFiles && <LinearProgress />}
                                                <p style={DEFAULT_DROPZONE_STYLE.text}>Files to be added ({quote.assignFiles.length})</p>
                                                <ul>{quote.assignFiles.map(f => <li key={f.id} style={DEFAULT_DROPZONE_STYLE.listItem}>{f.fileName}</li>)}</ul>
                                            </>;
                                        } else {
                                            return <>
                                                {props.isUploadingFiles && <LinearProgress />}
                                                <p style={DEFAULT_DROPZONE_STYLE.text}>Click here or drag/drop a file to upload it</p>
                                            </>;
                                        }
                                    })()}
                                </Grid>
                            </Grid>
                        </Dropzone>
                    </FormControl>
                    <TagListEditor isResourceOnly={false} initialTags={quote.tags} onTagsChanged={props.onTagsChanged} onFetchTags={props.onSearchTags} onResolveTags={props.onResolveTags} />
                </div>
            </ExpansionPanelDetails>
        </ExpansionPanel>
    </>
}



// WEBPACK FOOTER //
// ./src/components/material/edit-quote.tsx